import React, { useEffect, useState } from 'react'
import Header from '../../components/home/Header'
import MesSelecionado from '../../components/extratos/MesSelecionado'
import { useLocation } from 'react-router-dom';
import ContentBox from '../../components/ContentBox';
import ListarNoticias from '../../components/ListarNoticias';
import NoticiasApi from '../../services/robinhood/NoticiasApi';

export default function NoticiasPeriodo() {
  const location = useLocation();
  const periodo = location.state ? location.state.periodo : { 'mes_id': (new Date().getMonth() + 1), 'ano': (new Date().getFullYear()) };
  const [publicacoes, setPublicacoes] = useState([]);
  const [publicacao, setPublicacao] = useState([]);

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush';


  }, []);
  useEffect(() => {
    new NoticiasApi().mesAno(periodo.mes_id, periodo.ano).then(response => setPublicacoes(response));

    return () => {

    }
  }, [periodo])

  const handlePublicacao = (_publicacao) => {
    setPublicacao(_publicacao);
  }

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '20px', marginBottom: '20px' }}> <i className='zmdi zmdi-reader'></i> PUBLICAÇÕES  </h5>
        <MesSelecionado periodo={periodo} ></MesSelecionado>
        {publicacoes.length == 0 && <h6 className='m-l-20 text-muted'><i class="zmdi zmdi-info"></i>  NÃO FORAM ENCONTRADAS PUBLICAÇÕES PARA O PERÍODO SELECIONADO</h6>}
      </Header>

      {publicacoes.length > 0 && <ListarNoticias publicacoes={publicacoes} handlePublicacao={handlePublicacao} />}

      <div class="modal fade" id="largeModalPublicacao" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" style={{ textTransform: 'uppercase' }} id="largeModalLabel">{publicacao.titulo}</h6>
            </div>

            <div class="modal-body">
              <p className='bold'><i className='zmdi zmdi-calendar'></i> {publicacao.data_publicacao && publicacao.data_publicacao.split('-').reverse().join('/')} </p>
              <div className="content" dangerouslySetInnerHTML={{ __html: publicacao.noticia }}></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-link waves-effect btn-light" data-dismiss="modal"> FECHAR</button>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}